import { FC } from "react";
import { IClassname } from "@/lib/types/classname";

export const FilterSS: FC<IClassname> = ({ className }) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.90476 9.5H6.42857M19 7.25H16.7143C16.1081 7.25 15.5267 7.01295 15.098 6.59099C14.6694 6.16903 14.4286 5.59674 14.4286 5H9.85714C9.85714 5.59674 9.61633 6.16903 9.18767 6.59099C8.75902 7.01295 8.17764 7.25 7.57143 7.25H3V17H16.7143C17.3205 17 17.9019 16.7629 18.3305 16.341C18.7592 15.919 19 15.3467 19 14.75V7.25ZM15.1905 11.75C15.1905 10.9544 14.8694 10.1913 14.2978 9.62868C13.7263 9.06607 12.9511 8.75 12.1429 8.75C11.3346 8.75 10.5594 9.06607 9.98787 9.62868C9.41633 10.1913 9.09524 10.9544 9.09524 11.75C9.09524 12.5457 9.41633 13.3087 9.98787 13.8713C10.5594 14.4339 11.3346 14.75 12.1429 14.75C12.9511 14.75 13.7263 14.4339 14.2978 13.8713C14.8694 13.3087 15.1905 12.5457 15.1905 11.75Z"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};
